import { Loader } from '@googlemaps/js-api-loader'

function getApiKey () {
    return 'AIzaSyBT6-uQGG6l4gvIfnzpnrap6tliDZGn59w'
}

function getMapCenter (mapWrapper) {
    const lat = parseFloat(mapWrapper.getAttribute('data-lat'))
    const lng = parseFloat(mapWrapper.getAttribute('data-lng'))

    return { lat, lng }
}

function getMapZoom () {
    return 11
}

function getMapOptions (mapWrapper) {
    return {
        center: getMapCenter(mapWrapper),
        zoom: getMapZoom(),
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false
    }
}

function addMarker (google, map, position) {
    new google.maps.Marker({ map, position })
}

function loadMap (mapWrapper) {
    const mapLoader = new Loader({
        apiKey: getApiKey(),
        version: 'weekly'
    })

    const mapOptions = getMapOptions(mapWrapper)
    const markerPosition = getMapCenter(mapWrapper)

    mapLoader
        .load()
        .then(google => {
            const map = new google.maps.Map(mapWrapper.querySelector('#position-map'), mapOptions)
            addMarker(google, map, markerPosition)
        })
        .catch(error => console.log(error))
}

export default function PositionMap () {
    const mapWrapper = document.querySelector('.mtt-single-sidebar-map')

    if (mapWrapper) {
        loadMap(mapWrapper)
    }
}